import type { Element } from 'slate';
import { Text } from 'slate';

export function isDescriptionNodesEmpty(nodes?: Element[]): boolean {
  if (!nodes || nodes.length === 0) return true;
  if (nodes.length > 1) return false;

  const { children } = nodes[0];
  const [first] = children;

  return (
    children.length === 0 || (children.length === 1 && Text.isText(first) && first.text === '')
  );
}
